require('styles/App.less');
import $ from 'jquery'

import React, {
  Component,
  PropTypes
} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions/const';
import { Link } from 'react-router'

import Header from '../components/Header'
import Footer from '../components/Footer'

let config = require('config');

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  componentDidMount() {
    var ua = navigator.userAgent.toLowerCase();
    ua = {
      isLtIE8   : typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
      isLtIE9   : document.uniqueID && typeof window.matchMedia == "undefined",
      isIE      : document.uniqueID,
      isFirefox : /firefox/.test(ua),
      isChrome  : /chrome/.test(ua),
      isSafari  : /safari/.test(ua) && !/chrome/.test(ua),
      isWebKit  : /applewebkit/.test(ua),
      isMobile  : /mobile/.test(ua),
      isIOS     : /i(phone|pod|pad)/.test(ua),
      isIPhone  : /iphone/.test(ua),
      isIPad    : /ipad/.test(ua),
      isAndroid : /android/.test(ua)
    }
    if (ua.isMobile || ua.isAndroid || ua.isIOS) {
      $("html").addClass("mobile");
    }
  }
  render() {
    const {actions, data, routes, children, params} = this.props;
    return (
      <div id="container">
        <Header routes={routes} params={params} />
        <div id="content">{children}</div>
        <Footer />
      </div>
    )
  }
}

App.propTypes = {
  actions: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const props = {
    data:state.data
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./containers/App.js